import { pagesipdus } from "./rutainicial";

const ligasipdus = pagesipdus + "2026/Inv/";

export const invitaciones2026 = [
    {
        'numInvitacion' : 'SIPDUS-GEH-FOFIR-ITP-2-2026.',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SIPDUS-GEH-FOFIR-ITP-2-2026.',
                'vigenciaProc' : 'Vigencia: 27 de agosto de 2026 (único día)',
                'descripcionProc' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de los Mercados Municipales Actopan; ubicado en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligasipdus }ITP1/ITP1.rar`,
                'resultadosProc' : [
                    // {
                    //     'resultado' : 'Oficio Invitación',
                    //     'urlResultado' : `${ ligasipdus }ITP1/ITP1.rar.pdf`,
                    // },
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligasipdus }ITP2/JAITP-2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligasipdus }ITP2/APITP2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligasipdus }ITP2/FAITP2.pdf`,
                    }
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SIPDUS-GEH-FOFIR-ITP-1-2026.',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SIPDUS-GEH-FOFIR-ITP-1-2026.',
                'vigenciaProc' : 'Vigencia: 27 de agosto de 2026 (único día)',
                'descripcionProc' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de los Mercados Municipales Huichapan; ubicado en la localidad y Municipio de Huichapan, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligasipdus }ITP1/ITP1.rar`,
                'resultadosProc' : [
                    // {
                    //     'resultado' : 'Oficio Invitación',
                    //     'urlResultado' : `${ ligasipdus }ITP1/ITP1.rar.pdf`,
                    // },
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligasipdus }ITP1/JAITP-1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligasipdus }ITP1/APITP1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligasipdus }ITP1/FAITP1.pdf`,
                    }
                ]
            }
        ]
    }
]